export const list_api = {
  url: 'memberSalesLists',
  title: " 列表",
  method: "post"
}
export const export_api = {
  url: 'memberListDownload',
  title: "会员交易导出",
  method: "post"
}
export const upload_api = {
  // url: 'memberSalesUpload',
  url: "memberListUpload",
  title: "交易导入",
  method: "post"
}

// excelheadermembersale

// export const fileHeader_api = {
//   url: 'excelheadermembersale',
//   title: "",
//   method: "get"
// }


// WEBPACK FOOTER //
// ./src/views/base/membersales/desc.js